import PropTypes from 'prop-types'
import React, { useContext, useState } from 'react'

import CurrencyInput from 'react-currency-input'
import InputMask from 'react-input-mask'
import Context from '../../context'

import { ClearStringNumber } from '../../helpers/ClearStringNumber'

function UnityDataForm({ title }) {
  const { formObject, setFormObject } = useContext(Context)
  const [averageTicketMaskedValue, setAverageTicketMaskedValue] = useState('0,00')

  const handleAverageTicketValueChange = (event, maskedvalue, floatvalue) => {
    setAverageTicketMaskedValue(maskedvalue)
    setFormObject({ ...formObject, averageTicket: floatvalue })
  }

  return (
    <>
      <h5>{title}</h5>
      <div className="form-row">
        <div className="form-group col-6">
          <input
            value={formObject.site}
            onChange={e => setFormObject({ ...formObject, site: e.target.value })}
            placeholder="Site"
            className="form-control"
            type="text"
          />
        </div>
        <div className="form-group col-6">
          <input
            value={formObject.facebook}
            onChange={e => setFormObject({ ...formObject, facebook: e.target.value })}
            placeholder="Facebook"
            className="form-control"
            type="text"
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group col-6">
          <input
            value={formObject.instagram}
            onChange={e => setFormObject({ ...formObject, instagram: e.target.value })}
            placeholder="Instagram"
            className="form-control"
            type="text"
          />
        </div>
        <div className="form-group col-6">
          <InputMask
            mask="(99) 9 9999-9999"
            value={formObject.whatsapp}
            onChange={e =>
              setFormObject({
                ...formObject,
                whatsapp: ClearStringNumber(e.target.value)
              })
            }
            type="text"
            className="form-control"
            placeholder="Whatsapp"
          />
        </div>
        <div className="col-6" style={{ padding: 5 }}>
          <div className="form-group ">
            <label htmlFor="averageTicket">Valor do ticket Médio</label>
            <CurrencyInput
              value={averageTicketMaskedValue}
              onChangeEvent={handleAverageTicketValueChange}
              id="averageTicket"
              className="form-control"
              decimalSeparator=","
              thousandSeparator="."
              prefix="R$ "
            />
          </div>
        </div>
      </div>
    </>
  )
}

UnityDataForm.defaultProps = {
  title: 'Informações sobre a Unidade'
}

UnityDataForm.propTypes = {
  title: PropTypes.string
}

export default UnityDataForm
